import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 7v5","key":"svg-1"}]]

const IconClockHour12 = createReactComponent('outline', 'clock-hour-12', 'ClockHour12', __iconNode);

export default IconClockHour12;